const BEFORE_AFTER = 'before-after';
const BEFORE_AFTER_SEARCH = 'before-after-search';
const ROOTSOURCE1 = 'rootsource1';
const ROOTSOURCE2 = 'rootsource2';
const VIDEO_STRAIGHT = 'videostraight';
const VIDEO_CURLY = 'videocurly';
const VIDEO_3 = 'video3';
export const VIDEO_PP = 'pp';

const supplementsVariantsImages = [
  ROOTSOURCE1,
  ROOTSOURCE2,
  BEFORE_AFTER,
  BEFORE_AFTER_SEARCH,
] as const;

export const supplementsVariantsVideos = [VIDEO_STRAIGHT, VIDEO_CURLY, VIDEO_3, VIDEO_PP] as const;

export const supplementsAllVariants = [...supplementsVariantsImages, ...supplementsVariantsVideos];
